import React from "react";
import "./calc.css";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import FilterContainer from "./containers/FilterContainer";
import Footer from "./components/Footer";
//console.log("src/App_calc.js");

function App() {
  return (
    <div className="App">
      <Header />
      <Navbar />
      <FilterContainer />
      <Footer />
    </div>
  );
}

export default App;
